import {
  GET_COMPANIES,
  GET_COMPANY_DETAILS,
  UPDATE_COMPANY_SETTING,
  GET_BUSINESS_TYPES,
  GET_COMPANY_DETAILS_GST,
  GET_COMPANY,
  UPDATE_DYNAMIC_BARCODE,
  GET_GST_ENTRY,
} from '../types';

const initialState = {
  list: [],
  single: null,
  details: null,
  businessTypes: null,
  gstDetail: null
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_COMPANIES:
      return { ...state, list: payload };
    case GET_COMPANY:
      return { ...state, single: payload };

    case GET_COMPANY_DETAILS:
      return { ...state, details: payload };

    case UPDATE_COMPANY_SETTING:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case GET_BUSINESS_TYPES:
      return { ...state, businessTypes: payload };

    case GET_COMPANY_DETAILS_GST:
      return { ...state, gstDetail: payload };

    case UPDATE_DYNAMIC_BARCODE:
      return { ...state, barcode: payload };

    case GET_GST_ENTRY:
      return { ...state, gstEntryDetail: payload };

    default:
      return state;
  }
};

export default reducer;
